import axios from 'axios';

// Determine API base URL:
// 1. REACT_APP_API_URL (explicit override)
// 2. REACT_APP_BACKEND_URL (standard env var)
// 3. Localhost fallback for development
// NOTE: Do NOT auto-detect from window.location — frontend & backend run on
//       different subdomains in Coolify/VPS deployments.
const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    // Ensure no trailing slash
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');
  }
  // Fallback to localhost for local development
  return 'http://localhost:8000/api/v1';
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
